/**
 * Client-side quality floor for article preview images.
 *
 * The Liquid templates already skip images whose stored dimensions fall below
 * the floor — but several WordPress-imported articles carry metadata that
 * lies (the admin records 900x506 while the actual file is 300x168), and the
 * server side can only see the metadata. This measures what the browser
 * actually decoded and swaps in the branded fallback tile when the real
 * pixels are below the floor declared on the wrapper.
 *
 * Wrappers opt in with `data-image-floor="MINWxMINH"` and provide the
 * localized tile label via `data-floor-label` and the article title via
 * `data-floor-title` (shown as the tile's focus).
 */
(function () {
  function buildTile(label, title) {
    const tile = document.createElement('div');
    tile.className = 'aqive-article-fallback';
    tile.setAttribute('aria-hidden', 'true');

    const glyph = document.createElement('span');
    glyph.className = 'aqive-article-fallback__glyph';
    glyph.textContent = '氣';
    tile.appendChild(glyph);

    if (title) {
      const heading = document.createElement('span');
      heading.className = 'aqive-article-fallback__title';
      heading.textContent = title;
      tile.appendChild(heading);
    }

    const text = document.createElement('span');
    text.className = 'aqive-article-fallback__label';
    text.textContent = label || '';
    tile.appendChild(text);

    return tile;
  }

  function check(img, wrapper, minW, minH) {
    if (!img.isConnected || img.naturalWidth === 0) return;
    if (img.naturalWidth >= minW && img.naturalHeight >= minH) return;
    img.replaceWith(
      buildTile(
        wrapper.getAttribute('data-floor-label'),
        wrapper.getAttribute('data-floor-title')
      )
    );
  }

  function init() {
    document.querySelectorAll('[data-image-floor]').forEach(function (wrapper) {
      const parts = (wrapper.getAttribute('data-image-floor') || '').split('x');
      const minW = parseInt(parts[0], 10);
      const minH = parseInt(parts[1], 10);
      if (!minW || !minH) return;

      wrapper.querySelectorAll('img').forEach(function (img) {
        if (img.complete) {
          check(img, wrapper, minW, minH);
        } else {
          img.addEventListener('load', function () {
            check(img, wrapper, minW, minH);
          }, { once: true });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true, passive: true });
  } else {
    init();
  }

  // The theme editor re-renders sections after this script has run; without
  // this the freshly rendered cards keep their undersized images.
  document.addEventListener('shopify:section:load', init, { passive: true });
})();
